"use client";
// РУКА 2 (по Р-020). Нижнее меню на телефоне — как в макете: Главная · Каталог · По фото · Корзина · Войти.
// В макете оно «прилипает» к низу всего сайта; у нас закреплено к низу экрана (site-extra.css).
import { Suspense } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useCart } from "@/ruka2/cart";
import { Icon, type IconName } from "./icons";

const TABS: [string, string, IconName][] = [
  ["/", "Главная", "home"],
  ["/catalog", "Каталог", "grid"],
  ["/podbor", "По фото", "cam"],
  ["/cart", "Корзина", "cart"],
  ["/account", "Кабинет", "user"],
];

// Адрес страницы известен только при запросе — без Suspense страница не собирается заранее (cacheComponents).
// Пока адрес не пришёл, меню то же, только без подсветки текущего пункта.
export function Tabbar() {
  return (
    <Suspense fallback={<TabbarView path={null} />}>
      <TabbarLive />
    </Suspense>
  );
}

function TabbarLive() {
  return <TabbarView path={usePathname()} />;
}

function TabbarView({ path }: { path: string | null }) {
  const n = useCart().reduce((s, l) => s + l.qty, 0);
  return (
    <div className="sx tabbar-wrap">
      <nav className="tabbar" aria-label="Быстрые ссылки">
        {TABS.map(([href, label, icon]) => (
          <Link key={href} href={href} className={path === href ? "on" : ""}>
            <Icon name={icon} />
            {label}
            {href === "/cart" && n ? <span className="n">{n}</span> : null}
          </Link>
        ))}
      </nav>
    </div>
  );
}
